/**
 * v3.15-1162 — About (sells trust, not history).
 */
import PublicLayout from '../components/PublicLayout';
import EndPageCTA from '../components/EndPageCTA';
import EcosystemGraphic from '../components/EcosystemGraphic';
import { HubDashboardScreenshot } from '../components/HubProductImagery';

const AboutPage = () => (
  <PublicLayout testId="about-page">

    {/* HERO — manifesto headline */}
    <section className="bg-white px-6 py-32 lg:py-44">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-8">About Prestigious Hub</p>
        <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold text-primary leading-[1.05] tracking-tight">
          We don&rsquo;t just<br />process deals.<br />
          <span className="text-gradient-gold">We protect relationships.</span>
        </h1>
        <p className="mt-10 text-xl sm:text-2xl text-slate-600 font-light max-w-3xl leading-relaxed">
          Prestigious Hub is the financial concierge platform partners trust with their most valuable clients.
        </p>
      </div>
    </section>

    {/* Pillars — short, punchy, no cards */}
    <section className="bg-slate-900 text-white px-6 py-28 lg:py-36">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Technology</p>
          <p className="font-heading text-2xl font-bold leading-tight">
            One platform. Three services. Zero portal-hopping.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">People</p>
          <p className="font-heading text-2xl font-bold leading-tight">
            One Concierge per client. End-to-end. By name.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Outcomes</p>
          <p className="font-heading text-2xl font-bold leading-tight">
            Approvals delivered. Partners protected. Clients re-engaged.
          </p>
        </div>
      </div>
    </section>

    {/* Operator positioning — proof: real Hub */}
    <section className="bg-white px-6 py-28 lg:py-36">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-[1.1] mb-10">
            Built by operators.<br />
            <span className="text-slate-600">Trusted by partners.</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed max-w-xl mb-6">
            Over two decades inside the businesses we now serve. We know what kills a deal. We know what slows a file. We built Prestigious Hub to remove every one of those things — and pair every client with a human who owns the outcome.
          </p>
          <div className="grid grid-cols-2 gap-6 max-w-md">
            <div>
              <p className="font-heading text-3xl font-bold text-gradient-gold leading-none">20+ yrs</p>
              <p className="mt-2 text-sm text-slate-600">Operating experience across the businesses we serve</p>
            </div>
            <div>
              <p className="font-heading text-3xl font-bold text-gradient-gold leading-none">~150</p>
              <p className="mt-2 text-sm text-slate-600">Active lending partners across all programs</p>
            </div>
          </div>
        </div>
        <HubDashboardScreenshot />
      </div>
    </section>

    {/* The Platform — one line, no list */}
    <section className="bg-gradient-to-b from-slate-50 to-white px-6 py-28 lg:py-36">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-[10px] uppercase tracking-[0.3em] text-gold/80 mb-2">Prestigious Companies</p>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Prestigious Hub · Financial Concierge Platform</p>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-primary leading-[1.1] mb-12">
          Consumer Funding. Business Funding.<br />
          <span className="text-gradient-gold">CreditForward360.</span>
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed mb-4">
          Three first-class services. One Concierge model. Submit a client once — we route, work, and fund inside the Hub.
        </p>
        <p className="text-sm text-slate-500 max-w-2xl mx-auto leading-relaxed">
          <strong className="text-slate-700">EasyQuickFund</strong> powers consumer &amp; business funding. <strong className="text-slate-700">CreditForward360</strong> helps today&rsquo;s decline become tomorrow&rsquo;s approval. <strong className="text-slate-700">Ghost Intelligence™</strong> keeps every file moving 24/7.
        </p>
      </div>
    </section>

    {/* Ecosystem graphic */}
    <section className="bg-white px-6 py-24 lg:py-28">
      <div className="max-w-5xl mx-auto">
        <EcosystemGraphic testId="about-ecosystem-graphic" />
      </div>
    </section>

    <EndPageCTA testId="about-end-cta" />
  </PublicLayout>
);

export default AboutPage;
